import React, { useState, useEffect, useRef } from "react";
import BannerTwo from "../components/BannerTwo";
import DealsOne from "../components/DealsOne";
import TopSellingOne from "../components/TopSellingOne";
import TrendingOne from "../components/TrendingOne";
import DiscountOne from "../components/DiscountOne";
import FeaturedOne from "../components/FeaturedOne";
import BigDealOne from "../components/BigDealOne";
import TopSellingTwo from "../components/TopSellingTwo";
import BrandTwo from "../components/BrandTwo";
import ShippingTwo from "../components/ShippingTwo";
import FeatureOne from "../components/FeatureOne";
import { api } from "../include/api";
import Layout from "../components/user/Layout";
import { useLocation } from "react-router-dom";
import { loadCartData } from "../helper/cartUtils";
import { getCustomer } from "../include/function";

const HomePageTwo = () => {
  const [fetchLoading, setFetchLoading] = useState(true);

  const [dayDeals, setDayDeals] = useState([]);
  const [hotDeals, setHotDeals] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [newArraivals, setNewArraivals] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const customer = getCustomer();
  const [dealsOfTheDayCategoryId, setDealsOfTheDayCategoryId] = useState(null);
  const [hotDealsCategoryId, setHotDealsCategoryId] = useState(null);
  const [bestSellerCategoryId, setBestSellerCategoryId] = useState(null);
  const [cartData, setCartData] = useState([]);
  const [addedToCartMap, setAddedToCartMap] = useState({});
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const handleCartUpdate = () => {
      loadCartData(customer.id, setCartData, setAddedToCartMap);
    };

    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);

  const topBrandsRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    getCategory();
    getHomeCategory();
    getBrand();
  }, []);

  const getCategory = () => {
    setFetchLoading(true);
    api
      .get("/category/?parentId=0")
      .then((response) => {
        if (response.status === 200) {
          setCategoryList(
            response.data.data.filter((cl) => cl.name !== "Home"),
          );
        }
      })
      .catch(() => {
        setCategoryList([]);
      })
      .finally(() => setFetchLoading(false));
  };

  const getBrand = () => {
    setFetchLoading(true);
    api
      .get("/brand/")
      .then((response) => {
        if (response.status === 200) {
          setBrandList(response.data.data.filter((cl) => cl.name !== "Home"));
        }
      })
      .catch(() => {
        setBrandList([]);
      })
      .finally(() => setFetchLoading(false));
  };

  const getHomeCategory = () => {
    setFetchLoading(true);
    api
      .get("/category/?flag=getHomeAndChilds")
      .then((response) => {
        if (response.status === 200) {
          const Allitems = response.data.data[0].childs;
          const deals1 = Allitems.find(
            (item) => item.name === "Deals Of The Day",
          );
          const deals2 = Allitems.find((item) => item.name === "Hot Deals");
          const deals3 = Allitems.find((item) => item.name === "Best Sellers");
          const deals4 =
            Allitems.find((item) => item.name === "New Arrivals")?.products ||
            [];

          if (deals1) setDealsOfTheDayCategoryId(deals1.id);
          if (deals2) setHotDealsCategoryId(deals2.id);
          if (deals3) setBestSellerCategoryId(deals3.id);

          setDayDeals(deals1?.products || []);
          setHotDeals(deals2?.products || []);
          setBestSellers(deals3?.products || []);
          setNewArraivals(deals4);
        }
      })
      .catch(() => {})
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    if (location.hash && !fetchLoading) {
      const id = location.hash.replace("#", "");
      let attempts = 0;
      const maxAttempts = 20;

      const scrollToSection = () => {
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -90;
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          // Check if it's too close to the bottom of the document
          const maxScroll = document.body.scrollHeight - window.innerHeight;
          const targetScroll = Math.min(y, maxScroll);

          window.scrollTo({ top: targetScroll, behavior: "smooth" });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(scrollToSection, 100);
        }
      };
      setTimeout(scrollToSection, 200);
    }
  }, [location, fetchLoading]);

  useEffect(() => {
    const id = location.hash.replace("#", "");
    if (!id) return;

    let attempts = 0;
    const maxAttempts = 10;

    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -90;
        const rectTop = el.getBoundingClientRect().top;
        const scrollTop = window.pageYOffset;
        const sectionTop = rectTop + scrollTop + yOffset;

        const maxScrollTop =
          document.documentElement.scrollHeight - window.innerHeight;

        const finalScrollTop = Math.min(sectionTop, maxScrollTop);
        window.scrollTo({ top: finalScrollTop, behavior: "smooth" });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToSection, 100);
      }
    };

    setTimeout(scrollToSection, 200);
  }, [location]);
  const triggerReload = () => {
    setReloadKey((prev) => prev + 1);
  };
  // In HomePageTwo
  useEffect(() => {
    const handleReload = () => {
      triggerReload();
    };

    window.addEventListener("homePageReload", handleReload);
    return () => window.removeEventListener("homePageReload", handleReload);
  }, []);

  return (
    <>
      <Layout>
        {/* BannerTwo */}
        <BannerTwo />

        <FeatureOne categoryList={categoryList} />

        {/* DealsOne */}
        <div id="Deal_of_The_Day">
          <DealsOne
            key={`DealsOne-${reloadKey}`}
            dayDeals={dayDeals}
            categoryList={categoryList}
            dealsOfTheDayCategoryId={dealsOfTheDayCategoryId}
            addedToCartMap={addedToCartMap}
            setCartData={setCartData}
            setAddedToCartMap={setAddedToCartMap}
          />
        </div>

        {/* TopSellingOne */}
        <div id="top_selling_products">
          <TopSellingOne
            key={`TopSellingOne-${reloadKey}`}
            bestSellers={bestSellers}
            bestSellerCategoryId={bestSellerCategoryId}
            addedToCartMap={addedToCartMap}
            setCartData={setCartData}
            setAddedToCartMap={setAddedToCartMap}
          />
        </div>

        {/* TrendingOne */}
        <div id="trending_products">
          <TrendingOne
            key={`TrendingOne-${reloadKey}`}
            newArraivals={newArraivals}
            categoryList={categoryList}
            addedToCartMap={addedToCartMap}
            setCartData={setCartData}
            setAddedToCartMap={setAddedToCartMap}
          />
        </div>

        {/* DiscountOne */}
        <DiscountOne />

        {/* FeaturedOne */}
        <FeaturedOne
          key={`FeaturedOne-${reloadKey}`}
          hotDeals={hotDeals}
          hotDealsCategoryId={hotDealsCategoryId}
          addedToCartMap={addedToCartMap}
          setCartData={setCartData}
          setAddedToCartMap={setAddedToCartMap}
        />

        {/* BigDealOne */}
        <BigDealOne />

        {/* TopSellingTwo */}
        <TopSellingTwo
          key={`TopSellingTwo-${reloadKey}`}
          bestSellers={bestSellers}
          bestSellerCategoryId={bestSellerCategoryId}
          addedToCartMap={addedToCartMap}
          setCartData={setCartData}
          setAddedToCartMap={setAddedToCartMap}
        />

        {/* BrandTwo */}
        <div
          id="top_brands"
          ref={topBrandsRef}
          style={{ paddingTop: "100px", marginTop: "-100px" }}
        >
          <BrandTwo brandList={brandList} />
        </div>

        {/* ShippingTwo */}
        <ShippingTwo />
      </Layout>
    </>
  );
};

export default HomePageTwo;
